import React from 'react';
import classes from './styles.module.scss';
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon
} from '@chakra-ui/react';
import clsx from 'clsx';

const List = ({ content }) => {
  const { title, items } = content;
  return (
    <div>
      {title && <p>{title}</p>}
      <ul className={classes.listStyle}>
        {items.map((item, i) => (
          <li key={i}>
            <ListItem item={item} />
          </li>
        ))}
      </ul>
    </div>
  );
};

const ListItem = ({ item }) => {
  if (typeof item === 'string') {
    return <span>{item}</span>;
  }
  const { title, description, noTitleColon } = item;
  return (
    <span>
      {title && (
        <b>
          {title}
          {!noTitleColon && ':'}{' '}
        </b>
      )}
      {description}
    </span>
  );
};
const Section = ({ title, description, content }) => (
  <div className={classes.section}>
    {title && <h2>{title}</h2>}
    {description && <p>{description}</p>}
    {content && <p>{content}</p>}
  </div>
);

const Content = ({ content }) => {
	if (Array.isArray(content)) {
		return (
			<>
				{content.map((item, index) => {
					if (!item.type || item.type === 'text') {
						const thisContent = item.list ? <List content={item.list} /> : null;
						return (
							<Section
								key={item.title}
								title={item.title}
								subheader={item.subtitle}
								description={item.description}
								content={thisContent}
								formula={item.formula}
								extended={item.extends}
							/>
						);
					}
				})}
			</>
		);
	}

	return (
		<p className={classes.normalAnswer}>{content}</p>
	);
};

const FAQ = ({ list,showLength,isNotBlog }) => {
  return (
    <Accordion allowMultiple className={clsx(classes.blogContainer,isNotBlog && classes.container)}>
      {list
        .filter((item, index) => index < showLength || list.length)
        .map((val, index) => (
          <AccordionItem className={classes.item} key={index}>
            <AccordionButton>
              <h2 className={classes.question}>{val.question}</h2>
              <AccordionIcon fontSize={'35px'} color="#FFC165" />
            </AccordionButton>
            <AccordionPanel pb={4} className={classes.answer}>
              <Content content={val.answer} />
            </AccordionPanel>
          </AccordionItem>
        ))}
    </Accordion>
  );
};

export default FAQ;
